import { styled } from 'linaria/react';

import { COLORS } from '../../../styles/constants';
import ImportedStyledTitle from '../../UI/ContentTitle/styled';

export const StyledTitle = styled(ImportedStyledTitle)`
  padding: 16px 0 16px 24px;
  color: ${({ isDark }) => (isDark ? COLORS.white[100] : COLORS.brown.dark[100])};
`;
